import {ButtonVariant} from '@/components/common/content/ButtonTypes'
import {QueryLink} from '@/utils/constants'
import {PricingTabType} from '@/utils/pricing'
import {routeTo} from '@/utils/router'

export const getRegistrationCard = (
  linkHref?: string | QueryLink,
  description?: string,
  buttonVariant?: ButtonVariant,
  visibleOnMobile?: boolean,
) => ({
  key: 'registration',
  linkHref: linkHref || routeTo.verification.form(),
  labels: ['brand-protection-card-registration-label'],
  title: 'brand-protection-card-registration-title',
  description: description || 'brand-protection-card-registration-desc',
  buttonText: 'button-start-with-lawyer-check',
  buttonVariant: buttonVariant || ButtonVariant.primary,
  visibleOnMobile: visibleOnMobile || true,
})

export const getLegalServiceCard = () => ({
  key: 'legal-service',
  linkHref: routeTo.legalServices(),
  labels: ['brand-protection-card-ip-service-label'],
  title: 'brand-protection-card-ip-service-title',
  description: 'brand-protection-card-ip-service-desc',
  buttonText: 'button-find-out-more',
  buttonVariant: ButtonVariant.secondary,
  visibleOnMobile: false,
})

export const getTmRenewalCard = () => ({
  key: 'tm-renewal',
  linkHref: routeTo.trademarkRenewal.home(),
  labels: ['brand-protection-card-tm-renewal-label'],
  title: 'brand-protection-card-tm-renewal-title',
  description: 'brand-protection-card-tm-renewal-desc',
  buttonText: 'button-find-out-more',
  visibleOnMobile: false,
  buttonVariant: ButtonVariant.secondary,
})

export const getMonitoringCard = (
  linkHref?: string | QueryLink,
  description?: string,
  buttonText?: string,
  buttonVariant?: ButtonVariant,
  visibleOnMobile?: boolean,
) => ({
  key: 'monitoring',
  linkHref: linkHref || routeTo.brandMonitoring.home(),
  labels: ['brand-protection-card-monitoring-label'],
  title: 'brand-protection-card-monitoring-title',
  description: description || 'brand-protection-card-monitoring-desc',
  buttonText: buttonText || 'button-find-out-more',
  buttonVariant: buttonVariant || ButtonVariant.secondary,
  visibleOnMobile: visibleOnMobile || false,
  priceNote: 'per-month-text',
})

export const getInfringementCard = () => ({
  key: 'infringement',
  linkHref: routeTo.pricing(PricingTabType.BrandProtection),
  labels: ['brand-protection-card-ip-service-label'],
  title: 'brand-monitoring.brand-protection-infringement-card-title',
  description: 'brand-protection-card-ip-service-desc',
  buttonText: 'button-find-out-more',
  buttonVariant: ButtonVariant.secondary,
  visibleOnMobile: false,
})
